// src/aiq/services/ScreenerService.ts

import { API_BASE_URL } from '../../config';

export interface ScreenerResult {
    ticker: string;
    alpha_score?: number;
    bear_alpha?: number;
    bull_alpha?: number;
    sharpe_ratio_1y?: number;
    volatility_90d?: number;
    beta_vs_spy?: number;
    [key: string]: any; // Allow dynamic fields
}

export const runScreener = async (query: string, token: string) => {
    try {
        const response = await fetch(`${API_BASE_URL}/ai_lab/screener`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ 
                query,
                costs_credit: true // This is a premium feature
            })
        });

        if (!response.ok) {
            const err = await response.json();
            throw new Error(err.error || "Screener failed");
        }

        return await response.json();
    } catch (e) {
        console.error("Screener Service Error:", e);
        throw e;
    }
};